var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26557 0.108423L7.88987 3.72352C8.03671 3.86776 8.03671 4.10099 7.88987 4.24522L7.66803 4.46311C7.52119 4.60735 7.28373 4.60735 7.13689 4.46311L4 1.32369L0.863112 4.46004C0.716266 4.60428 0.478812 4.60428 0.331966 4.46004L0.110134 4.24215C-0.0367117 4.09792 -0.0367116 3.86469 0.110134 3.72045L3.73443 0.105354C3.88127 -0.0358123 4.11873 -0.0358122 4.26557 0.108423Z",
    fill: "#656668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.4326d76d5923c03fff4088e6e9b9e57b.svg";
export { ForwardRef as ReactComponent };